import type { ReactNode } from "react";
import { Tab as HeadlessUITab } from "@headlessui/react";
import { isFunction, noop } from "lodash";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface GroupProps {
  children: ReactNode;
  className?: string;
  id?: string;
  onChange?: (index: number) => void;
  selectedIndex?: number;
}

export const Group = ({ children, className = "", ...props }: GroupProps) => (
  <HeadlessUITab.Group
    as="div"
    data-testid="tab-group"
    selectedIndex={props.selectedIndex}
    onChange={
      isFunction(props.onChange)
        ? (index: number) => {
            props.onChange?.(index);
          }
        : noop
    }
    className={classNames("text-dark size-full overflow-auto", className)}
    {...props}
  >
    {children}
  </HeadlessUITab.Group>
);

Group.displayName = "Tab.Group";
